import { z } from 'zod';
import { ItemIdSchema } from '../../models/items';
import { InventorySchema } from '../../models/inventory';
import { OperationIdSchema } from '../../ids';
import { GrimoireViewSchema } from '../../models/grimoire';
import { API_PREFIX, defineEndpoint } from '../endpoint';

/** The own Grimoire and slots' choices. */
export const getGrimoire = defineEndpoint({
  method: 'GET',
  path: `${API_PREFIX}/me/grimoire`,
  access: 'session',
  response: GrimoireViewSchema,
});

/**
 * Chooses what goes in a skill slot (WT-2, MU-6): 1 and 2 for `family`'s techniques (opened by its
 * mastery or not yet: one not opened waits), 3 to 6 a spell learned; null clears it.
 */
export const putLoadout = defineEndpoint({
  method: 'PUT',
  path: `${API_PREFIX}/me/loadout`,
  access: 'session',
  body: z.object({
    slot: z.number().int().min(1).max(6),
    family: z.string().max(32).optional(),
    technique: z.string().max(32).nullable(),
  }),
  response: GrimoireViewSchema,
});

/** Reads a tome of the backpack (GS-1): its spell learned for good, the tome spent. */
export const learnFromTome = defineEndpoint({
  method: 'POST',
  path: `${API_PREFIX}/me/grimoire/tome`,
  access: 'session',
  body: z.object({ operationId: OperationIdSchema, item: ItemIdSchema }),
  response: z.object({
    operationId: OperationIdSchema,
    spell: z.string(),
    grimoire: GrimoireViewSchema,
    inventory: InventorySchema,
  }),
});
